import { select } from 'redux-saga/effects';

import ReactGA from 'react-ga';
import * as actions from '../state';

// eslint-disable-next-line import/prefer-default-export
export function* initializeReactGA() {
  const PORTAL_TRACK_ANALYTICS = yield select((state) => actions.selectConfig(state, 'PORTAL_TRACK_ANALYTICS'));

  if (PORTAL_TRACK_ANALYTICS?.toLowerCase() === 'yes'
    || PORTAL_TRACK_ANALYTICS?.toLowerCase() === 'true'
    || PORTAL_TRACK_ANALYTICS?.toLowerCase() === '1'
  ) {
    ReactGA.initialize('UA-97865765-3');
    ReactGA.pageview('/analytics');

    setInterval(() => {
      ReactGA.event({
        category: 'Session',
        action: 'Keep-Alive',
      });
    }, 120000);
  }
}
